import { GetStaticPropsContext, InferGetStaticPropsType, NextPage } from 'next';

import { extractHeadings } from 'utils/structured-text.utils';

import { Duration } from 'constants/duration.constants';
import { NOT_FOUND } from 'constants/nextjs.constants';
import { privacyPolicyQuery } from 'queries/global/queries';
import Prefetcher from 'services/prefetcher';

import CustomPageTextContainer from 'components/@custom-pages/CustomPageTextContainer';
import AppNavigation from 'components/@navigation/AppNavigation';
import PageSeo from 'components/@seo/PageSeo';

const PrivacyPolicy: NextPage<
  InferGetStaticPropsType<typeof getStaticProps>
> = ({ seoTags, title, body, updatedAt, headings }) => {
  return (
    <AppNavigation>
      <PageSeo tags={seoTags} />
      <CustomPageTextContainer
        title={title}
        body={body}
        updatedAt={updatedAt}
        headings={headings}
      />
    </AppNavigation>
  );
};

export default PrivacyPolicy;

export const getStaticProps = async ({
  locale,
  preview,
}: GetStaticPropsContext) => {
  const prefetcher = await Prefetcher.init({ locale, preview });

  const { pagePrivacyPolicy } = await prefetcher.prefetch(privacyPolicyQuery);

  if (!pagePrivacyPolicy) return { ...NOT_FOUND };

  return {
    props: {
      seoTags: pagePrivacyPolicy.seoTags,
      title: pagePrivacyPolicy.title,
      body: pagePrivacyPolicy.body,
      updatedAt: pagePrivacyPolicy.updatedAt,
      headings: extractHeadings(pagePrivacyPolicy.body),
      dehydratedState: prefetcher.dehydratedState,
    },
    revalidate: Duration.TEN_MIN,
  };
};
